export const commonIssueViewGranularScopes = ['write:issue:jira', 'read:issue-field-values:jira'];
